export default "__VITE_ASSET__d03917fc__"